define([
    'common/domain/entity/blob',
    'common/domain/collection/blob',
    'common/ui/template/blob/item.hbs',
    'common/ui/template/blob/list.hbs',
    'common/util',
    'backbone',
    'backbone.marionette'
], function(
    BlobModel,
    BlobCollection,
    BlobItemViewTemplate,
    BlobListViewTemplate,
    Balus,
    Backbone
    ){

    var BlobItemView = Backbone.Marionette.View.extend({
        model: BlobModel,
        tagName: 'li',
        className: 'blob-list-item',
        template: BlobItemViewTemplate,
        events: {
            'click': 'toggle'
        },

        initialize: function() {
            _.bindAll(this, 'activate', 'deactivate', 'toggle');
            this.listenTo(this.model, 'activate', this.activate);
            this.listenTo(this.model, 'deactivate', this.deactivate);
        },

        onRender: function() {
            var j = this.model.toJSON();
            j.size_str = this.model.prettySizeString();
            this.$el.tooltip({title: `${j.filename} (${j.size_str})`});
        },

        serializeData: function() {
            var json = this.model.toJSON();
            json.isImage = this.model.isImage();
            json.type = this.model.getFileType();
            json.link = this.model.url();
            return json;
        },

        activate: function() {
            this.$el.addClass('is-active');
        },

        deactivate: function() {
            this.$el.removeClass('is-active');
        },

        toggle: function() {
            this.trigger('select:blob', this.model);
            this.model.toggle();
        }
    });

    var BlobListView = Backbone.View.extend({
        childViewEvents: {
            'select:blob': 'blobSelected'
        },

        initialize: function(params) {
            this._blobs = params.blobs;
            this._imageOnly = params.imageOnly;
            this._multiple = params.multiple;
            _.bindAll(this, 'addOne', 'addAll', 'onlyBlobSelected');
        },

        render: function() {
            this.listenTo(this._blobs, 'add', this.addOne);
            this.listenTo(this._blobs, 'reset', this.addAll);
            this.$el.html(BlobListViewTemplate());

            this.addAll();
            return this;
        },

        addOne: function(blob) {
            if(this._imageOnly && !blob.isImage()) {
                return;
            }
            var view = new BlobItemView({model: blob});
            this.$('.blob-list').prepend(view.render().$el);
            if(!this._multiple) {
                this.listenTo(view, 'select:blob', this.onlyBlobSelected);
            }
        },

        addAll: function() {
            this.$('.blob-list li').remove();
            this._blobs.each(this.addOne);
        },

        onlyBlobSelected(model) {
            _.each(this._blobs.models, blob => {
                if(blob.get('blob_id') !== model.get('blob_id')){
                    blob.deactivate();
                }
            });
        }
    });

    return BlobListView;
});



// WEBPACK FOOTER //
// ./common/ui/view/blob/list.js